import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import { ContentProvider } from "@/context/ContentContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Partnership from "@/pages/Partnership";
import Manufacturing from "@/pages/Manufacturing";
import Projects from "@/pages/Projects";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/partnership" element={<Partnership />} />
              <Route path="/manufacturing" element={<Manufacturing />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        </ContentProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
